import { EditOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { useCallback } from 'react';

export interface IDraggableActionsButtonProps {
  onEdit?: (e: any) => void;
  onRemove?: (e: any) => void;
  onAdd?: (e: any) => void;
}

const useCallbackCancelEvent = (callback?: (e: any) => void) => {
  return useCallback(
    (e: any) => {
      if (callback) {
        callback(e);
        e.preventDefault();
        e.stopPropagation();
      }
    },
    [callback],
  );
};

export function DraggableActionsButton(props: IDraggableActionsButtonProps) {
  const { onEdit, onRemove, onAdd } = props;

  const handleRemove = useCallbackCancelEvent(onRemove);
  const handleEdit = useCallbackCancelEvent(onEdit);
  const handleAdd = useCallbackCancelEvent(onAdd);

  return (
    <Space size={6} className="actions-buttons">
      {onRemove && (
        <Button size="small" icon={<MinusOutlined />} onClick={handleRemove} />
      )}
      {onEdit && (
        <Button
          size="small"
          icon={<EditOutlined />}
          type="primary"
          onClick={handleEdit}
        />
      )}
      {onAdd && (
        <Button
          size="small"
          icon={<PlusOutlined aria-hidden="true" />}
          onClick={handleAdd}
        />
      )}
    </Space>
  );
}
